import React, { useEffect, useRef } from 'react'
import { useSwipeable } from 'react-swipeable'

import './styles.css'
import { useDetectClickOutsideWithExclude } from '../../hooks/useDetectClickOutsideWithExclude'
import { useScrollTop } from '../../hooks/useScrollTop'
function BottomSheet({
  open = false,
  children,
  onToggle,
  onBack,
  className = '',
  title = '',
  hideOverlay = false,
  closeOnClickOutside = false,
  spaceFromTop = 94,
  transparentOverlay = false,
  scrollResetContent = 0
}) {
  const handlers = useSwipeable({
    onSwipedDown: onToggle,
    onSwipedUp: onToggle,
    preventScrollOnSwipe: true,
  })

  useEffect(() => {
    if (open) {
      document.body.classList.add('freeze')
    } else {
      document.body.classList.remove('freeze')
    }

    return () => {
      document.body.classList.remove('freeze')
    }
  }, [open])

  const ref = useDetectClickOutsideWithExclude(() => {
    onToggle()
  }, ['swiper-package-mobile'])

  const { scrollRef } = useScrollTop()

  useEffect(() => {
    scrollRef.current.scrollTo(0, 0)
  }, [scrollResetContent, scrollRef])

  const headerRef = useRef()

  return (
    <>
      {open && !hideOverlay && (
        <div
          className={`fixed ${
            transparentOverlay ? 'bg-transparent' : 'bg-[rgba(0,0,0,.6)]'
          } h-screen w-screen left-0 top-0 z-[100]`}
          onClick={() => {
            onToggle()
          }}
        ></div>
      )}
      <div
        {...(closeOnClickOutside ? { ref } : {})}
        className={`bottom-sheet bg-[white] rounded-t-[16px] mt-[-16px] fixed left-[0] bottom-[0] w-full z-[1000] overflow-hidden transition-all duration-[400ms] ease-in-out ${
          open ? '' : 'max-h-0'
        } z-[200] ${className}`}
        style={open ? { maxHeight: `calc(100% - ${spaceFromTop}px` } : {}}
      >
        <div ref={headerRef}>
          <div className="h-[34px] flex items-center justify-center" {...handlers}>
            <div className="h-[4px] w-[32px] bg-[#E5E7ED] rounded-full"></div>
          </div>
          {title && <div className="text-[14px] my-[10px] px-[24px] text-[#C7CCD9] font-medium">{title}</div>}
        </div>
        <div
          onClick={(e) => e.stopPropagation()}
          className="p-[24px] pt-[0] overflow-y-scroll"
          ref={scrollRef}
          style={{ maxHeight: `calc(${window.innerHeight - spaceFromTop - headerRef?.current?.clientHeight}px)` }}
        >
          {children}
        </div>
      </div>
    </>
  )
}

export default BottomSheet
